import { Button } from '@talentmesh/ui/components/button';
import ErrorDialog from '../Errors/Components/ErrorDialog';
import { resourceBaseUrl } from '@/AppSettings';
import { CompanyLogo } from '@/Components/shared';
import RoutePath from '@/Routing/RoutePath';
import useTalentMeshHistory from '@/Routing/useTalentMeshHistory';
import UIStrings from '@/Utils/UIStrings';

function NotFoundPageContainer() {
    const history = useTalentMeshHistory();

    return (
        <ErrorDialog
            errorTitle={UIStrings.Found404}
            errorBody={
                <div className="flex flex-col gap-4">
                    <p className="text-foreground text-base leading-relaxed">{UIStrings.PageNotFoundTextBeforeLink}</p>
                    <Button
                        type="button"
                        className="h-11 w-full max-w-46 rounded-xl"
                        onClick={() => {
                            history.push(RoutePath.Root);
                        }}
                    >
                        {UIStrings.GoToTalentMesh}
                    </Button>
                </div>
            }
            errorLogo={
                <div className="mb-12 flex flex-col items-center justify-center gap-3">
                    <CompanyLogo width={195} height={37.5} color="primary" aria-label={UIStrings.CompanyLogo} />
                    <img
                        src={`${resourceBaseUrl}/general/404.svg`}
                        alt={UIStrings.PageNotFound}
                        className="h-auto max-h-[min(40vh,320px)] w-full max-w-sm object-contain md:max-h-none"
                        width={416}
                        height={416}
                        loading="eager"
                        decoding="async"
                    />
                </div>
            }
        />
    );
}

export default NotFoundPageContainer;
